import { Link } from "react-router";
import Banner from "@components/Banner/Banner";
import { PodcastKeywordData } from "@pages/Section/layouts/PodcastsPage/utils/types";
import { cn } from "@util/helpers";

type PodcastKeywordBannerProps = {
  /** Podcast keyword banner details */
  details: PodcastKeywordData;
};

/**
 * PodcastsBanner component for displaying podcast keyword information in keyword pages.
 * figma: https://www.figma.com/design/rmzJoZwUpb3iLm6lMDXJ2W/BT-MASTER--WEB-?node-id=2746-15874&t=AsmANtczrMBLYmgj-4
 */
const PodcastsBanner = ({
  details: { label, description, thumbnailSrc, subscribe },
}: PodcastKeywordBannerProps): React.ReactElement => {
  return (
    <Banner rootClassName="w-ful px-0 [&>div.container]:px-0">
      <div className={cn("flex flex-col items-start", "lg:flex-row")}>
        <img
          loading="lazy"
          src={thumbnailSrc}
          alt={label}
          width="120"
          height="120"
          aria-label={label}
          className="mb-4 mr-4 aspect-square"
        />

        <div className="d-flex flex-column justify-content-center lg:max-w-7/10">
          <h5
            className={cn(
              "mb-4 font-public-sans text-base font-normal text-gray-850 lg:text-lg"
            )}
          >
            {description}
          </h5>

          <div className="flex flex-wrap items-center">
            <p
              className={cn(
                "mb-0 mr-2 inline font-public-sans text-base font-medium text-gray-850",
                "lg:inline lg:text-lg"
              )}
            >
              Subscribe:
            </p>

            <div>
              {subscribe?.map(({ platform, link }) => (
                <Link
                  key={`${link}-${platform}`}
                  className={cn(
                    "relative mx-2 inline-block font-poppins text-base font-semibold text-black first:ml-0 first:mr-2 hover:underline",
                    "before:absolute before:-left-2 before:h-full before:w-[1px] before:bg-gray-650 first:before:hidden",
                    "lg:text-lg"
                  )}
                  to={link}
                  rel="noreferrer"
                  target="_blank"
                  aria-label={platform}
                >
                  {platform}
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>
    </Banner>
  );
};

export default PodcastsBanner;
